import React from 'react';
import { ChevronDoubleUpIcon } from '@heroicons/react/solid';

const BackToTop = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      className="h-12 w-12 shrink-0 rounded-full bg-gradient-to-br from-secondary to-secondary-dark flex items-center justify-center text-white cursor-pointer hover:opacity-90 max-[575px]:absolute max-[575px]:-top-[18px] max-[575px]:right-[2%]"
      onClick={scrollToTop}
      type="button"
      tabIndex={0}
    >
      <ChevronDoubleUpIcon className="h-6 w-6 text-white" />
    </button>
  );
};

export default BackToTop;
